import 'react-toastify/dist/ReactToastify.css';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import '../../../scss/forms.scss'
import '../../../scss/modal.scss';
//import './_style.scss'

import React from 'react'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { Row, Col, Card, CardHeader, CardBody, Label, Button, Input, Modal, ModalBody, ModalFooter, ModalHeader, Form, FormFeedback, FormGroup} from 'reactstrap'
import { Formik } from 'formik';
import * as Yup from 'yup'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { toast } from 'react-toastify';

import * as UsuariosPreparacaoActions from '../../../store/ducks/protocolo/usuarios_preparacao/actions';
import DynamicForm from '../../../components/DynamicForm';
import PaginationControl from '../../UI/paginationControl';

const validationSchema = function (values) {
  return Yup.object().shape({
    matricula: Yup.string()
    .required('Digite a Matrícula'),
    nome: Yup.string()
    .required('Digite o Nome'),
  })
}

const initialValues = {
  matricula: "",
  nome: ""
}

const removeLetters = (e) => {
  if (!e || !e.target) return "";
  return e.target.value.replace(/\D/g, '');
};

class UsuarioPreparacao extends React.Component {
  constructor (props) {
    super(props)
    
    this.state = {
      dados: [],
      usuarioDeletar: [],
      modalAdicionarUsuarios: false,
      fields: [
        {
          name: 'codigo',
          type: 'number',
          placeholder: 'Código',
          label: 'Código',
          sizeSm: 4,
          sizeMd: 3,
          maxLength: 4,
        },
        {
          name: 'matricula',
          type: 'number',
          placeholder: 'Matrícula',
          label: 'Matrícula',
          sizeSm: 4,
          sizeMd: 3,
          maxLength: 5,
        },
        {
          name: 'nome',
          type: 'text',
          placeholder: 'Nome',
          label: 'Nome',
          sizeSm: 4,
          sizeMd: 3,
          maxLength: 50,
        }
      ]
    }

    this.options = {
      sortIndicator: true,
      hideSizePerPage: true,
      paginationSize: 3,
      hidePageListOnlyOnePage: true,
      clearSearch: true,
      alwaysShowAllBtns: true,
      withFirstAndLast: true,
      sizePerPage: 5,
      noDataText: 'Não existem dados para exibição.',
      firstPageTitle: 'Ir para primeira página',
      lastPageTitle: 'Ir para última página',
      lastPageText: 'Última página',
      nextPageTitle: 'Próxima página',
      prePageTitle: 'Página anterior',
    }

    this.limpar = this.limpar.bind(this)
    this.pesquisar = this.pesquisar.bind(this)
    this.adicionar = this.adicionar.bind(this)
    this.deletar = this.deletar.bind(this)
    this.gridRecepcaoAcoes = this.gridRecepcaoAcoes.bind(this)

    this.openModalDeletarUsuario = this.openModalDeletarUsuario.bind(this)

  }

  componentDidMount() {
    this.props.actions.recoverPreparations();
  }

  componentDidUpdate() {
    if (this.props.data.create) {
      toast.success(<div>Usuário {this.props.data.item.nome} inserido com sucesso. <br></br> Código do usuário: {this.props.data.item.codigo}</div>);
      this.props.actions.recoverPreparations();
    }
    if (this.props.data.delete) {
      toast.success(<div>Usuário {this.state.usuarioDeletar.nome} deletado com sucesso.</div>);
      this.limpar();
      this.props.actions.recoverPreparations();
    }
  }

  openModalAdicionarUsuario() {
    this.setState({ modalAdicionarUsuarios: !this.state.modalAdicionarUsuarios });
  }

  openModalDeletarUsuario( row = [] ) {
    this.setState({ usuarioDeletar: row });
    this.setState({ modalDeletarUsuarios: !this.state.modalDeletarUsuarios });
  }

  pesquisar(values) {
    let filter = '';
    if (!!values.codigo) {
      filter = `${filter}${!!filter ? '&' : '?'}codigo=${values.codigo}`;
    }
    if (!!values.matricula) {
      filter = `${filter}${!!filter ? '&' : '?'}matricula=${values.matricula}`;
    }
    if (!!values.nome) {
      filter = `${filter}${!!filter ? '&' : '?'}nome=${values.nome}`;
    }
    this.props.actions.recoverPreparations(filter);
  }

  limpar () {
    this.refs.form.clearForm();
    this.props.actions.recoverPreparations();
  }

  adicionar(data) {
    let item = {
      matricula: data.matricula,
      nome: data.nome
    }

    this.props.actions.createPreparation(item);

    this.openModalAdicionarUsuario();
  }

  deletar() {
    this.props.actions.deletePreparation(this.state.usuarioDeletar._id);
    this.setState({ modalDeletarUsuarios: false });
  }

  gridRecepcaoAcoes (cell, row) {
    return (
      <div>
        <Button
          color='ghost-primary'
          className="btn-space"
          style={{marginLeft: '10px'}}
          onClick={() => {
            this.openModalDeletarUsuario(row)
          }}
        >
          <i className='fa fa-trash' />
        </Button>
      </div>
    )
  }

  findFirstError (formName, hasError) {
    const form = document.forms[formName]
    for (let i = 0; i < form.length; i++) {
      if (hasError(form[i].name)) {
        form[i].focus()
        break
      }
    }
  }

  validateForm (errors) {
    this.findFirstError('adicionarUsuario', (fieldName) => {
      return Boolean(errors[fieldName])
    })
  }

  handlerSelectAll =  (event, outro) => {
    this._tableDynamicGrid.handleSelectAllRow(event);
  }

  render () {

    return (

      <div className="recepcao-usuarios">

        <Modal isOpen={this.state.modalDeletarUsuarios} className="modal-contrato">
            <ModalHeader>Deletar Usuário</ModalHeader>
            <ModalBody>
              <p className="text-alert no-border">Deseja deletar o usuário {this.state.usuarioDeletar.nome}?</p>
            </ModalBody>
            <ModalFooter>
              <Button className="btn_success" onClick={this.deletar}>Confirmar</Button>
              <Button className="btn_danger" onClick={this.openModalDeletarUsuario.bind(this)}>Cancelar</Button>
            </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.modalAdicionarUsuarios} className="modal-contrato">
            <ModalHeader>Inserção de usuário de preparação</ModalHeader>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={this.adicionar}
                render={
                  ({
                    values,
                    errors,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue
                  }) => (
              <div>
                <Form onSubmit={handleSubmit} noValidate name='adicionarUsuario' autoComplete='off'>
  
                  <ModalBody>

                    <Row className='mt-2'>
                      <Col md={12}>
                        <FormGroup>
                          <Label>Matrícula</Label>
                          <Input
                            innerRef={element => (this.add_matricula = element)}
                            name='matricula'
                            invalid={!!errors.matricula}
                            type='text'
                            className='form-control'
                            placeholder=''
                            maxLength='5'
                            onChange={(e) => setFieldValue('matricula', removeLetters(e))}
                            required
                            onBlur={handleBlur}
                            value={values.matricula}
                          />
                          <FormFeedback>{errors.matricula}</FormFeedback>
                        </FormGroup>
                        
                      </Col>

                      <Col md={12}>
                        <FormGroup>
                          <Label>Nome</Label>
                          <Input
                            innerRef={element => (this.add_nome = element)}
                            name='nome'
                            maxLength='50'
                            invalid={!!errors.nome}
                            type='text'
                            className='form-control'
                            placeholder=''
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.nome}
                          />
                          <FormFeedback>{errors.nome}</FormFeedback>
                        </FormGroup>
                        
                      </Col>
                    </Row>
                    
                  </ModalBody>
                  <ModalFooter>
                    <Button className="btn_success" type="submit" onClick={() => this.validateForm(errors)}>Cadastrar</Button>
                    <Button className="btn_danger" onClick={this.openModalAdicionarUsuario.bind(this)}>Cancelar</Button>
                  </ModalFooter>
                </Form>
              </div>
            )} />
        </Modal>

        <Row>
          <Col sm={12}>
            <Card>
              <CardHeader>
                Consulta de Usuário de Preparação
              </CardHeader>
              <CardBody>
                <DynamicForm
                  ref="form"
                  fields={this.state.fields}
                  onSubmit={this.pesquisar}>
                    <Col md={12} className='text-right'>
                      <Button color='btn btn-success' onClick={this.openModalAdicionarUsuario.bind(this)}>Adicionar</Button>
                      <Button color='btn btn-primary'>Pesquisar</Button>
                      <Button className="btn-primary" onClick={this.limpar}>Limpar</Button>
                    </Col>
                </DynamicForm>
                <div>
                  <Row className='mt-3 row_protocolo'>
                    <Col>
                      <BootstrapTable
                        className='cor_azul contratos_table'
                        data={this.props.data.dados}
                        version='4'
                        striped
                        pagination
                        options={this.options}
                        selectRow={ this.selectRowProp }
                        ref={(t) => (this._tableDynamicGrid = t)}
                        trClassName={this.rowCheckContratoRecepcionado}>
                          <TableHeaderColumn dataField='codigo' width='80' dataFormat={this.gridRecepcaoAcoes}></TableHeaderColumn>
                          <TableHeaderColumn isKey dataField='codigo' dataSort> Código</TableHeaderColumn>
                          <TableHeaderColumn dataField='matricula' dataSort> Matrícula</TableHeaderColumn>
                          <TableHeaderColumn dataField='nome' dataSort> Nome</TableHeaderColumn>
                      </BootstrapTable>
                      <PaginationControl
                        itemsTotal={this.props.data.dados.length}
                        sizePerPage={this.options.sizePerPage}
                        tableRef={this._tableDynamicGrid}
                      />
                    </Col> 
                  </Row>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  data: state.usuariosPreparacao
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(UsuariosPreparacaoActions, dispatch)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UsuarioPreparacao);
